import React from 'react';
import './EventoSelecionados.css';
import { Typography, Grid, Container, Button } from '@mui/material';

const EVENT_IMAGE = encodeURI('/media/eventos/III Evento.jpg');
const EVENT_PDF = encodeURI('/media/pdfeventos/Caderno de resumos - III Evento.pdf');

export default function IIIEvento() {
    return (
        <div>
            <div className="TituloEventosSelecionados">
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                           
                            <Typography
                                       variant="h4"
                                       align="center"
                                       gutterBottom
                                       style={{
                                         fontFamily: "'Lato', serif",
                                         color: "white",
                                         borderBottom: "4px solid #d4af37",
                                         paddingBottom: "10px",
                                         textTransform: "uppercase",
                                         animation: "glow 2s infinite alternate",
                                         marginTop: "7%"  // Aqui é onde você define o espaço superior
                                       }}
                                     > 
                                     III Evento Internacional -
                                Aconselhar e prescrever em terras cristãs
                            </Typography>
                             
                        </Grid>
                    </Grid>
                </Container>
            </div>

            <div className="EventosMov">
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h1"
                                align="center"
                                gutterBottom
                                sx={{
                                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                                    fontWeight: 'bold',
                                    color: '#444',
                                }}
                            >
                                20, 21, 22 e 23 de setembro de 2021
                            </Typography>
                            <div className="border"></div>
                        </Grid>

                        <Grid item xs={12}>
                            <div className="evento-banner-row">
                                <img className="evento-banner-image" src={EVENT_IMAGE} alt="III Evento Internacional" />
                            </div>
                        </Grid>

                        {[
                            {
                                title: "Abertura & Mesa 1",
                                url: "https://www.youtube.com/embed/H9oXYsBMJPk",
                            },
                            {
                                title: "MESA 2: RECOMENDAÇÕES PARA O FORTALECIMENTO DA ALMA - ACONSELHAR E PRESCREVER EM TERRAS CRISTÃS",
                                url: "https://www.youtube.com/embed/1VdXflkRMaI",
                            },
                            {
                                title: "MESA 3: PRESCRIÇÕES PARA AS MULHERES - ACONSELHAR E PRESCREVER EM TERRAS CRISTÃS",
                                url: "https://www.youtube.com/embed/RiOgOehdDOc",
                            },
                            {
                                title: "Mesa 4: Recomendações de São Tomás de Aquino - Aconselhar e prescrever em terras cristãs",
                                url: "https://www.youtube.com/embed/8NNMOU4jEBw",
                            },
                            {
                                title: "Mesa 5: Prescrições para combater heresias e proteger a conduta eclesiástica",
                                url: "https://www.youtube.com/embed/SHuv2PshWSo",
                            },
                            {
                                title: "Mesa 6: Prescrições médicas - Aconselhar e prescrever em terras cristãs",
                                url: "https://www.youtube.com/embed/QU3veZol1dY",
                            },
                            {
                                title: "Mesa 7: Corrigir e disciplinar nos tempos modernos - Aconselhar e prescrever em terras cristãs",
                                url: "https://www.youtube.com/embed/lMVt4a610RY",
                            },
                        ].map((item, index) => (
                            <Grid item xs={12} md={6} key={index}>
                                <Typography
                                    variant="h2"
                                    gutterBottom
                                    sx={{
                                        fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
                                        fontWeight: 'bold',
                                        color: '#333',
                                    }}
                                >
                                    {item.title}
                                </Typography>
                                <div
                                    style={{
                                        borderRadius: '10px',
                                        overflow: 'hidden',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                        transition: 'transform 0.3s, box-shadow 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                                        },
                                    }}
                                >
                                    <iframe
                                        width="100%"
                                        height="225"
                                        src={item.url}
                                        title={`YouTube video player ${index}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </Grid>
                        ))}

                        <Grid item xs={12} sx={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                href={EVENT_PDF}
                                target="_blank"
                                sx={{
                                    fontSize: '1rem',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Baixar Caderno de Resumos
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </div>
    );
}
